// get products
export const getProducts = (products, category, type, limit) => {
  const finalProducts = category
    ? products.filter(
        (product) => product.category.filter((single) => single === category)[0]
      )
    : products;

  if (type && type === "new") {
    const newProducts = finalProducts.filter((single) => single.new);
    return newProducts.slice(0, limit ? limit : newProducts.length);
  }
  if (type && type === "bestSeller") {
    return finalProducts
      .sort((a, b) => {
        return b.saleCount - a.saleCount;
      })
      .slice(0, limit ? limit : finalProducts.length);
  }
  if (type && type === "saleItems") {
    const saleItems = finalProducts.filter(
      (single) => single.discount && single.discount > 0
    );
    return saleItems.slice(0, limit ? limit : saleItems.length);
  }
  return finalProducts.slice(0, limit ? limit : finalProducts.length);
};

// get product discount price
export const getDiscountPrice = (price, discount) => {
  return discount && discount > 0 ? price - price * (discount / 100) : null;
};

// get product cart quantity
export const getProductCartQuantity = (cartItems, product) => {
  let productInCart = cartItems.find((single) => single.id == product.id);
  if (cartItems.length >= 1 && productInCart) {
    return cartItems.find((single) => product.id == single.id)?.quantity;
  } else {
    return 0;
  }
};

export const cartItemStock = (item) => {
  if (item.quantity) {
    return item.quantity;
  }
};

//get products based on category
export const getSortedProducts = (products, sortType, sortValue) => {
  if (products && sortType && sortValue) {
    if (sortType === "brands") {
      return products.filter((product) => product.brand?.name == sortValue);
    }
    if (sortType === "category") {
      return products.filter(
        (product) =>
          product.category?.id == sortValue ||
          product.category?.parent_id == sortValue
      );
    }
    if (sortType === "search") {
      return products.filter((product) => product.name?.includes(sortValue));
    }
    if (sortType === "tag") {
      return products.filter(
        (product) => product.tag.filter((single) => single === sortValue)[0]
      );
    }
    if (sortType === "rating") {
      return products.filter((product) => product.rating_avg == sortValue);
    }
    if (sortType === "filterSort") {
      let sortProducts = [...products];
      if (sortValue === "default") {
        return sortProducts;
      }
      if (sortValue === "priceHighToLow") {
        return sortProducts.sort((a, b) => {
          return b.price - a.price;
        });
      }
      if (sortValue === "priceLowToHigh") {
        return sortProducts.sort((a, b) => {
          return a.price - b.price;
        });
      }
      if (sortValue === "dateNewToOld") {
        return sortProducts.sort((a, b) => {
          return new Date(b.updated_at) - new Date(a.updated_at);
        });
      }
      if (sortValue === "dateOldToNew") {
        return sortProducts.sort((a, b) => {
          return new Date(a.updated_at) - new Date(b.updated_at);
        });
      }
    }
  }
  return products;
};

// get individual element
const getIndividualItemArray = (array, categories = false) => {
  if (categories) return array;
  let individualItemArray = array.filter(function (v, i, self) {
    return i === self.indexOf(v);
  });
  return individualItemArray;
};

// get individual categories
export const getIndividualCategories = (categories) => {
  let productCategories = [];
  categories &&
    categories?.map((category) => {
      return productCategories.push(
        localStorage.getItem("i18nextLng") == "ar"
          ? {
              name: category?.name,
              id: category?.id,
              parent_id: category.parent_id,
            }
          : {
              name: category?.name_en,
              id: category?.id,
              parent_id: category.parent_id,
            }
      );
    });
  const individualProductCategories = getIndividualItemArray(
    productCategories,
    true
  );
  return individualProductCategories;
};

// get individual brands
export const getIndividualBrands = (products) => {
  let productBrands = [];
  products &&
    products.map((product) => {
      return product?.brand?.name && productBrands.push(product?.brand?.name);
    });
  const individualProductBrands = getIndividualItemArray(productBrands);
  return individualProductBrands;
};

// get individual ratings
export const getProductsIndividualRatings = (products) => {
  let productRatings = [];
  products &&
    products.map((product) => {
      return product.rating_avg
        ? productRatings.push(product.rating_avg)
        : null;
    });
  const individualProductSizes = getIndividualItemArray(productRatings);
  return individualProductSizes;
};

export const setActiveSort = (e) => {
  const filterButtons = document.querySelectorAll(
    ".sidebar-widget-list-left button, .sidebar-widget-tag button, .product-filter button"
  );
  filterButtons.forEach((item) => {
    item.classList.remove("active");
  });
  e.currentTarget.classList.add("active");
};

export const setActiveLayout = (e) => {
  const gridSwitchBtn = document.querySelectorAll(".shop-tab button");
  gridSwitchBtn.forEach((item) => {
    item.classList.remove("active");
  });
  e.currentTarget.classList.add("active");
};

export const toggleShopTopFilter = (e) => {
  const shopTopFilterWrapper = document.querySelector(
    "#product-filter-wrapper"
  );
  shopTopFilterWrapper.classList.toggle("active");
  if (shopTopFilterWrapper.style.height) {
    shopTopFilterWrapper.style.height = null;
  } else {
    shopTopFilterWrapper.style.height =
      shopTopFilterWrapper.scrollHeight + "px";
  }
  e.currentTarget.classList.toggle("active");
};
